import React from 'react';
import numeral from 'numeral';
import t from 'javascripts/utils/translation';

class AmountInputWithError extends React.Component {
  minimumAmount = (isSubscription) => {
    const {minAmount, subscriptionMinAmount} = this.props;
    return isSubscription ? subscriptionMinAmount : minAmount;
  };

  errorMsg = (isSubscription, amount) => {
    const {maxAmount, minAmount} = this.props;
    const parsedAmount = parseFloat(amount) || 0;

    if (isSubscription && (parsedAmount <= maxAmount)) {
      return t('views.donate_form.monthly_minimum_error', {amount: numeral(this.minimumAmount(isSubscription)).format('0,000')});
    } else if (parsedAmount > maxAmount) {
      return t('views.donate_form.maximum_amount_error', {amount: numeral(maxAmount).format('0,000.00')});
    } else {
      return t('views.donate_form.minimum_amount_error', {amount: numeral(minAmount).format('0,000.00')});
    }
  };
}

export default AmountInputWithError;
